import { Format, StyleColor } from '../../utils/styles-constants';
import styled from 'styled-components';

const inputHeight = 48;
const inputBorderWidth = 1;
const inputBoxHeight = inputHeight + 2 * inputBorderWidth;
const Input = styled('input') `
	box-sizing: border-box;
	outline: none;
	background-color: ${StyleColor.White};
	border-radius: 4px;
	border: ${inputBorderWidth}px solid ${StyleColor.Grey300};
	color: ${StyleColor.Grey700};
	font-size: 14px;
	height: ${inputHeight}px;
	margin: 0;
	padding: 0 20px;
	width: 100%;
	font-family: inherit;
	-webkit-appearance: none;

	&:focus,
	&:hover {
		border-color: ${StyleColor.Grey500};
	}

	&::placeholder {
		font-family: inherit;
		color: ${StyleColor.Grey400};
	}

	&[data-error = true] {
		border: 1px solid ${StyleColor.Red};
	}

	&[data-error = true]::placeholder {
		color: ${StyleColor.Red};
	}

	::-ms-clear {
		display: none;
	}
`;

const TextArea = styled('textarea') `
	box-sizing: border-box;
	outline: none;
	background-color: ${StyleColor.White};
	border-radius: 4px;
	border: 1px solid ${StyleColor.Grey300};
	color: ${StyleColor.Grey700};
	font-size: 14px;
	height: 68px;
	margin: 0;
	padding: 20px 20px;
	width: 100%;
	font-family: inherit;
	resize: none;

	-webkit-appearance: none;
	overflow: auto;//IE override

	&:focus,
	&:hover {
		border-color: ${StyleColor.Grey500};
	}

	&::placeholder {
		font-family: inherit;
		color: ${StyleColor.Grey400};
	}

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		margin-top: 10px;
	}
`;

export { Input, TextArea, inputBoxHeight };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Form/styles.ts